import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-video-modal',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './video-modal.component.html',
  styleUrls: ['./video-modal.component.css'],
})
export class VideoModalComponent implements OnChanges {
  @Input() videoUrl = '';
  @Input() show = false;
  @Output() close = new EventEmitter<void>();
  isLoading = true;

  safeVideoUrl: SafeResourceUrl = '';

  constructor(private sanitizer: DomSanitizer) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes['videoUrl'] && this.videoUrl) {
      this.safeVideoUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.videoUrl + '?autoplay=1');
      this.isLoading = true;
    }
  }

  closeModal() {
    this.close.emit();
  }

  handleIframeLoad() {
    this.isLoading = false;
  }
}